<template>
  <div>
    <f7-list-input
      v-if="scrollPicker"
      :value="renderValue()"
      v-bind="{...$attrs,...$props}"
      autocomplete="off"
      :error-message-force="!!form.errors[name]"
      :error-message="form.errors[name]"
      :readonly="true"
      :class="{readonly:overrideReadonly ? readonly : readonly || form.readonly}"
      :clear-button="!(overrideReadonly ? readonly : readonly || form.readonly) && clearButton"
      @input:clear="setValue(null)"
    >
      <slot></slot>
      <slot name="media" slot="media"></slot>
      <slot name="inner-start" slot="inner-start"></slot>
      <slot name="root-end" slot="root-end"></slot>
    </f7-list-input>
    <li 
        v-else
        class="col-100 medium-50 has-tooltip">
      <div class="item-content item-input " :class="getClasses()">
        <div class="item-inner">
          <div class="item-title item-label item-floating-label">{{label}}</div>
          <div class="item-input-wrap">
            <input :readonly="overrideReadonly ? readonly : readonly || form.readonly" :class="{readonly: overrideReadonly ? readonly : (readonly || form.readonly)}" name="fechaVisita" type="text" autocomplete="no" v-mask="['##:##']" placeholder="HH:MM" @change="onChange($event.target.value ? $event.target.value.split(':') : null)" :value="renderValue()" v-bind="{...$attrs,...$props}">
            <span v-if="!(overrideReadonly ? readonly : readonly || form.readonly) && clearButton" class="input-clear-button" @click="setValue(null)"></span>
            <f7-link
              v-if="hasHistory && Utils.posterior2Dic2024(form.dateRef)"
              :class="{ 'color-historico-ultimo-online': hayCambiosOnline() }"
              class="input-suffix-btn r-input-little r-input-top history-link"
              :icon-f7="'archivebox'"
              v-tooltip="'Historico de valores'"
              @click="showHistory"
            ></f7-link>
          </div>
        </div>
      </div>
    </li>
    <span v-if="htmlError" v-tooltip="tooltipError" v-html="htmlError()" @click.prevent="mostrarError()" style="z-index: 100;"></span>
    
    <f7-popover class="history-popover" :closeByBackdropClick="false" :backdrop="true" closeOnEscape ref="popoverHistory" style="width: auto; max-width: 90%;">
      <div style="min-width: 250px;">
        <f7-navbar :title="$t('Historico de cambios')">
          <f7-nav-right>
            <f7-link popover-close icon-f7="multiply"></f7-link>
          </f7-nav-right>
        </f7-navbar>
        <f7-block>
          <div class="scrollable-content">
            <table>
              <thead>
                <tr style="background-color: #22355b;color: #FFF;">
                  <th>Valor</th>
                  <th>Fecha</th>
                  <th>Usuario</th>
                </tr>
              </thead>
              <tbody  v-if="form.username != 'NOID'">
                <tr v-for="(itm, idx) in history" :key="'history-' + idx" :class="(idx%2?'fila-impar':'fila-par')">
                  <td class="datos-valor" :title="itm && itm.msgHistory?itm.msgHistory:''">{{getStrValueHistory(itm.valor)}}</td>
                  <td class="datos-auditoria">{{itm.date}}</td>
                  <td class="datos-auditoria">{{itm.username || ' - '}}</td>
                </tr>
              </tbody>
              <tbody  v-else>
                <tr v-for="(itm, idx) in history" :key="'history-' + idx" :class="(idx%2?'fila-impar':'fila-par')">
                  <td class="datos-valor" :title="itm && itm.msgHistory?itm.msgHistory:''">
                    <div>
                      <f7-list-input
                        :value="getValueHistory(itm.valor)"
                        :type="'datetime-local'"
                        @change="setValueHistory($event.target.value, $event.target, true, false, itm)"
                        :readonly="false"
                      ></f7-list-input>
                    </div>
                  </td>
                  <td class="datos-auditoria">
                    <f7-list-input
                      :value="getDateHistory(itm.date)"
                      :type="'datetime-local'"
                      @input="itm.date = $event.target.value"
                      @change="itm.date = $event.target.value"
                      @calendar:change="itm.date = $event.target.value"
                      v-on="$listeners"
                    ></f7-list-input>
                  </td>
                  <td class="datos-auditoria">{{itm.username || ' - '}}</td>
                  <td class="datos-opciones">
                    <f7-link @click="updateHistory(itm)" icon-f7="floppy_disk"></f7-link>
                    <f7-link @click="deleteFieldFromHistory(itm)" icon-f7="trash" color="red"></f7-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </f7-block>
      </div>
    </f7-popover>

  </div>
</template>
<style scoped>
</style>
<style>
.readonly input,
.readonly select {
  pointer-events: none;
}
</style>
<script>
import DateUtils from "./../js/DateUtils";
import Utils from "./../js/Utils";
import EntityUtils from "./../js/EntityUtils";
import JSONPath from 'jsonpath';

export default {
  data() {
    return {
      self: this,
      picker: null,
      fechaBaseData: this.fechaBase,
      // invalidValue: false,
      history: [],
      DateUtils,
      EntityUtils,
      JSONPath,
      Utils
    };
  },
  computed: {
    hasHistory: function () {
      return this.form?.history && this.form?.history[this.name];
    },
  },
  methods: {
    mostrarError: function() {
      const self = this;
      var app = self.$f7;
      let expediente = self.form.formData;
      let htmlError = expediente.listErrorsForLabel.filter(e => e.valor == (self.altername || self.name))
                .flatMap(e => e.errores)
                .map(e => '<div class="regla regla-'+e.tipoRegla+'" ><span style="color: black;">'+e.nombre + '.- </span>' + e.error+'</div>').join(' ');
      let msg = '<div>' + htmlError + '</div>';
      app.dialog.alert(msg,'Errores del campo');
    },
    htmlError: function() {
      const self = this;
      let expediente = self.form.formData;
      let msgError;
      if(expediente.listErrorsForLabel && expediente.listErrorsForLabel.filter(e => e.valor == (self.altername || self.name)).length)
      {
        msgError = EntityUtils.formateoError(expediente, self.altername || self.name);
      }
      return msgError;
    },
    tooltipError: function() {
      const self = this;
      let expediente = self.form.formData;
      let msgError;
      if(expediente.listErrorsForLabel && expediente.listErrorsForLabel.filter(e => e.valor == (self.altername || self.name)).length)
      {
        msgError = EntityUtils.tooltipError(expediente, (self.altername ||self.name));
      }
      return msgError;
    },
    getClasses: function() {
      const self = this;
      return {
        'item-input-with-value': !!self.getValue(),
        'item-input-outline': self.$attrs["outline"] != undefined
      };
    },
    setFechaBase(fechaBaseChange) {
      const self = this;
      self.fechaBaseData = fechaBaseChange;
    },
    getValue: function() {
      const self = this;
      var namespaces = self.name.split(".");
      var context = self.form.formData;
      for (var i = 0; i < namespaces.length; i++) {
        if (typeof context == "undefined") {
          let n = namespaces[i];
          if (0 === n % (!isNaN(parseFloat(n)) && 0 <= ~~n)) {
            //Número entero positivo
            context = [];
          } else {
            context = {};
          }
        }
        context = context[namespaces[i]];
      }
      return context;
    },
    showHistory: function(event) {
      const self = this;
      self.history = self.form.history[self.name];
      // vamos a formatear los campos de fecha
      for (var i = 0; i < self.history.length; i++) {
        if(self.history[i].valor === undefined) {
          self.history[i].valor = '';
        }
        if(self.history[i].valorAnterior === undefined) {
          self.history[i].valorAnterior = '';
        }

        self.history[i].valor = DateUtils.isDate(self.history[i].valor)?self.history[i].valor:DateUtils.dateFormat(self.history[i].valor, 'HH:mm');
        self.history[i].valorAnterior = DateUtils.isDate(self.history[i].valorAnterior)?self.history[i].valorAnterior:DateUtils.dateFormat(self.history[i].valorAnterior, 'HH:mm');

        self.history[i].date = DateUtils.dateFormat(self.history[i].date, 'DD/MM/YYYY HH:mm');
        self.history[i].username = self.history[i].username || '-';
      }
      if(event.target) self.$refs.popoverHistory.open(event.target);
    },
    hayCambiosOnline: function () {
      const self = this;
      // miramos si el usuario tiene rol ADMINISTRACION, ADMIN o DTYCAL 
      let colorear = false;
      let roles = self.form.user ? self.form.user.roles : null;
      if (roles && roles.length) {
        for (var i = 0; i < roles.length; i++) {
          if (roles[i] == 'ADMINISTRACION' || roles[i] == 'ADMIN' || roles[i] == 'DTYCAL') {
            colorear = true;
            break;
          }
        }
      }
      let history = self.form.history ? self.form.history[self.name] : null;
      // ahora ordenamos el historico por fecha y nos quedamos con el elemento mas reciente
      history = history ? [...history] : [];
      history = history.sort((a, b) => new Date(b.date) - new Date(a.date));
      // si el elemento mas reciente tiene el campo punto, devolveremos true
      return colorear && history && history.length && !history[0].esOffline;
    },
    noCoincideHistorico: function () {
      const self = this;
      // miramos si el usuario tiene rol ADMINISTRACION, ADMIN o DTYCAL 
      let nocoincide = false;
      let roles = self.form.user ? self.form.user.roles : null;
      if (roles && roles.length) {
        for (var i = 0; i < roles.length; i++) {
          if (roles[i] == 'ADMINISTRACION' || roles[i] == 'ADMIN' || roles[i] == 'DTYCAL') {
            nocoincide = true;
            break;
          }
        }
      }
      let history = self.form.history ? self.form.history[self.name] : null;
      // ahora ordenamos el historico por fecha y nos quedamos con el elemento mas reciente
      history = history ? [...history] : [];
      history = history.sort((a, b) => new Date(b.date) - new Date(a.date));
      // miraremos si el valor del historico más reciente, coincide con el del componente y si no coincide, devolveremos true
      return nocoincide && history && history.length && self.getStrValueHistory(history[0].valor) != self.getStrValueHistory(self.getValue());
    },
    getStrValueHistory(valor) {
      const self = this;
      let val = valor;
      
      return val;
    },
    getDateHistory(valor) {
      const self = this;
      let val = valor;
      if (val) {
        // si es un string con formato DD/MM/YYYY HH:mm lo convertimos a un objeto Date
        if (typeof val == "string" && (/^\d{2}\/\d{2}\/\d{4}[\s]+\d{2}:\d{2}(:\d{2})?$/i.test(val) )) {
          var dateParts = val.split(" ");
          var datePart = dateParts[0].split("/");
          var timePart = dateParts[1].split(":");
          // month is 0-based, that's why we need dataParts[1] - 1
          while (datePart.length < 3) {
            datePart.unshift(1);
          }
          val = new Date(datePart[2], datePart[1] - 1, + datePart[0], timePart[0], timePart[1]);
        }
        // si es una fecha en formato YYYY-MM-DD o YYYY-MM-DDTHH:mm la convertimos a un objeto Date
        else if (typeof val == "string" && (/^\d{4}-\d{2}-\d{2}[T\s]\d{2}:\d{2}:\d{2}$/i.test(val) || /^\d{4}-\d{2}-\d{2}[T\s]\d{2}:\d{2}$/i.test(val))) {
          val = new Date(val);
        }
        val = DateUtils.dateFormat(val, 'YYYY-MM-DDTHH:mm');
      }
      return val;
    },
    getValueHistory(valor) {
      const self = this;
      return valor;
    },
    setValueHistory: function(val, a, desdeChange = false, extraDataEmit = false, itm) {
      const self = this;
      itm.valor = val;
    },
    updateHistory: function(itm) {
      const self = this;
      // buscamos la entrada del historico en form.historyBulk por el id
      let historyBulk = self.form.historyBulk.find(h => h.id == itm.id);
      if(historyBulk) {
        historyBulk.date = new Date(self.getDateHistory(itm.date));
        historyBulk.username = itm.username;
      }
      let namespaces = self.name.split(".");
      let context = historyBulk?.nuevo;
      for (var i = 0; i < namespaces.length; i++) {
        if (i == namespaces.length - 1) {
          self.$set(context, namespaces[i], itm.valor);
        } else if (context[namespaces[i]] == null) {
          self.$set(context, namespaces[i], {});
        } else if (typeof context[namespaces[i]] == "undefined") {
          let n = namespaces[i + 1];
          if (0 === n % (!isNaN(parseFloat(n)) && 0 <= ~~n)) {
            //Número entero positivo
            self.$set(context, namespaces[i], []);
          } else {
            self.$set(context, namespaces[i], {});
          }
        }
        context = context[namespaces[i]];
      }
      context = itm.valor;
      // console.log("historyBulk", context);
      // ahora guardaremos el historico con su nuevo valor
      self.form.dbAdapter.saveHistory({ itemId: historyBulk.id, data: historyBulk })
        .then(function(res) {
          self.$f7.dialog.alert("El historico se ha actualizado correctamente.");
        })
        .catch(function(error) {
          if(error.status && error.status == 404) {
            console.log("error 404 URL: " + error.url);
          } else {
            app.dialog.alert(error.message);
          }
        });
      self.$refs.popoverHistory.close();
    },
    deleteFieldFromHistory: function(itm) {
      const self = this;
      self.$f7.dialog.confirm(
              "La línea de historico se eliminará y no podrá ser recuperada. ¿Está seguro?",
              "Advertencia",
              () => {
                // el delete va a ser un update en el que hemos eliminado el campo del valor actual
                let historyBulk = self.form.historyBulk.find(h => h.id == itm.id);
                let namespaces = self.name.split(".");
                let context = historyBulk?.nuevo;
                let contextParent = historyBulk?.nuevo;
                for (var i = 0; i < namespaces.length; i++) {
                  if (i == namespaces.length - 1) {
                    self.$set(context, namespaces[i], itm.valor);
                  } else if (context[namespaces[i]] == null) {
                    self.$set(context, namespaces[i], {});
                  } else if (typeof context[namespaces[i]] == "undefined") {
                    let n = namespaces[i + 1];
                    if (0 === n % (!isNaN(parseFloat(n)) && 0 <= ~~n)) {
                      //Número entero positivo
                      self.$set(context, namespaces[i], []);
                    } else {
                      self.$set(context, namespaces[i], {});
                    }
                  }
                  contextParent = context;
                  context = context[namespaces[i]];
                }
                // eliminamos el objeto context del contextParent
                if (contextParent) {
                  delete contextParent[namespaces[namespaces.length - 1]];
                  itm = undefined;
                }
                // ahora guardaremos el historico con su nuevo valor
                self.form.dbAdapter.saveHistory({ itemId: historyBulk.id, data: historyBulk })
                  .catch(function(error) {
                    if(error.status && error.status == 404) {
                      console.log("error 404 URL: " + error.url);
                    } else {
                      app.dialog.alert(error.message);
                    }
                  });
                self.$refs.popoverHistory.close();
              },
              () => {
                // Cancelar
              }
            );
      
    },
    renderValue: function() {
      var self = this;
      var context = self.getValue();
      if (context) {
        if (typeof context == "string") context = new Date(context);
        let value = [
          ("0" + context.getHours()).slice(-2),
          ("0" + context.getMinutes()).slice(-2)
        ];
        if (
          self.picker &&
          JSON.stringify(self.picker.getValue()) != JSON.stringify(value)
        ) {
          self.picker.setValue(value);
        }
        return value.join(":");
      } else {
        return null;
      }
    },
    setValue: function(val, a) {
      var self = this;
      var namespaces = self.name.split(".");
      var context = self.form.formData;
      for (var i = 0; i < namespaces.length; i++) {
        if (i == namespaces.length - 1) {
          self.$set(context, namespaces[i], val);
        } else if (typeof context[namespaces[i]] == "undefined") {
          let n = namespaces[i + 1];
          if (0 === n % (!isNaN(parseFloat(n)) && 0 <= ~~n)) {
            //Número entero positivo
            self.$set(context, namespaces[i], []);
          } else {
            self.$set(context, namespaces[i], {});
          }
        }
        context = context[namespaces[i]];
      }
    },
    onChange: function(value) {
      var self = this;
      let v = self.getValue();
      if (!!!value) {
        self.setValue(null);
        if (!self.scrollPicker) {
          self.$emit('change', value);
        }
        return;
      }
      if (v) {
        if (typeof v == "string") v = new Date(v);
      } else {
        v = self.fechaBaseData;
      }
      v.setHours(value[0]);
      v.setMinutes(value[1]);
      v = new Date(v);
      self.setValue(v, "calendar");
      if (!self.scrollPicker) {
        self.$emit('change', value.join(":"));
      }
    }
  },
  props: {
    fechaBase: {
      type: Date,
      default: function() {
        return new Date();
      }
    },
    name: {
      required: true,
      type: String
    },
    altername: {
      required: false,
      type: String,
      default: ''
    },
    form: {
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    overrideReadonly: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "text"
    },
    label: {
      type: String,
      default: ""
    },
    clearButton: {
      type: Boolean,
      default: false
    },
    scrollPicker: {
      type: Boolean,
      default: false
    },
    possibleHours: {
      type: String,
      default: function() {
        return Array.from({ length: 24 }, (_, i) => ("0" + i).slice(-2)).join(" ");
      }
    },
    possibleMinutes: {
      type: String,
      default: function() {
        return Array.from({ length: 60 }, (_, i) => ("0" + i).slice(-2)).join(" ");
      }
    }
  },
  mounted() {
    var $ = this.$$;
    var $el = $(this.$el);
    var self = this;
    var app = self.$f7;

    if(self.scrollPicker){
      self.picker = app.picker.create({
        inputEl: self.$$(self.$el).find("input")[0],
        rotateEffect: true,
        routableModals: false,
        toolbarCloseText: "Cerrar",
        cols: [
          {
            values: self.possibleHours.split(" ")
          },
          {
            divider: true,
            content: ":"
          },
          {
            values: self.possibleMinutes.split(" ")
          }
        ],
        on: {
          change: function(picker, value, displayValue) {
            self.onChange(value);
          }
        }
      });
    }
  }
};
</script>